import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Col, Row, Card, Input } from "reactstrap";
import DocumentsSubmission from "./DocumentsSubmission";
import AllSubmission from "./AllSubmission";
import ReactTable from "react-table";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes} from "@fortawesome/free-solid-svg-icons";
import FetchSubmissionListService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchSubmissionListService";
import ViewIcon from "../../../../../../../../designUtils/ProjectDashboard/ViewIcon.svg";
import CustomModal from "../../../../../../../Components/Modals/CustomModal";
import ProjectDashDeliveriesDetails from "../Deliveries/ProjectDashDeliveriesDetails";
import GraphicsSubmission from "./GraphicsSubmission";
import FetchCMProductDataService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchCMProductDataService";
import FetchGraphicsAssetsAsinWiseService from "../../../../../../../../Service/DashboardServices/ContentManagementServices/FetchGraphicsAssetsAsinWiseService";

function ProjectDashSubmissionMainPage(props) {
  const [searchASIN, setSearchASIN] = useState("");
  const [selectedCurrentPage, setSelectedCurrentPage] = useState(1);
  const [submissionSearchText, setSubmissionSearchText] = useState("");
  const [submissionList, setSubmissionList] = useState([]);
  const [selectedSubmission, setSelectedSubmission] = useState(null);
  const [isSubmissionModalOpen, setIsSubmissionModalOpen] = useState(false);
  const [selectedASIN, setSelectedASIN] = useState("Unmapped Assets");
  const [productList,setProductList]=useState('')
  const [fileList,setFileList]= useState("");
  const [docFileList,setDocFileList]= useState("");
  const [graphicsfileList,setGraphicsFileList]= useState("");
  const [isSubmissionClosed, setIsSubmissionClosed] = useState(false);
  const [asinCount,setAsinCount]=useState()
  const [unmappedCount,setUnmappedCount]=useState(0)
  const [submissionInnerCount,setSubmissionInnerCount]=useState()
  
  useEffect(() => {
    console.log(props.selectedProjectData)
    // FIXED: Changed && to || to properly check if data exists
    if (!props.selectedProjectData || !props.selectedProjectData.projectId) return;

    console.log(unmappedCount) 
    console.log(asinCount) 
    let data={
          asinList: props.selectedProjectData.asin,
          integerID: props.selectedProjectData.integerId,
          projectId: props.selectedProjectData.projectId,
        }
      FetchCMProductDataService(props.token,data).then((res)=>{
          if(res){
              console.log(res)
              setAsinCount(res.counts.resultcnt)
              setProductList(res.productsList)
              setUnmappedCount(res.counts&&res.counts.unmapped_count)
          }
      })
      handleAsinWiseProductList('Unmapped Assets')
    
  }, [props.selectedProjectData]); 

  const filteredProductList = productList
  ? productList.filter(asinObj =>
      asinObj.asin.toLowerCase().includes(searchASIN.toLowerCase())) : [];
  
      const filteredSubmissions = submissionList
      ? submissionList
          // .filter((submission) => {
          //   if (selectedASIN === "Others") {
          //     return !submission.submittedFor || submission.submittedFor.toLowerCase() === "Others";
          //   }
          //   return submission.submittedFor && submission.submittedFor.toLowerCase() === selectedASIN.toLowerCase();
          // })
          .filter((submission) => {
            const searchStr = submissionSearchText.toLowerCase();
            return (
              (submission.submissionName || "").toLowerCase().includes(searchStr) ||
              (submission.submittedBy || "").toLowerCase().includes(searchStr) ||
              (submission.submittedFor || "").toLowerCase().includes(searchStr) ||
              (submission.submittedOn || "").toLowerCase().includes(searchStr)
            );
          })     
      : [];    

      const columns = [
        { 
          Header: "Submission Name", 
          accessor: "submissionName",
          Cell: (rowInfo) => {
            const submission = rowInfo.original;
            return (
              <span
                style={{ 
                  cursor: 'pointer', 
                  color: '#0066cc'
                }}
                onClick={() => {
                  setSelectedSubmission(submission);
                  setIsSubmissionModalOpen(true);
                }}
              >
                {rowInfo.value}
              </span>
            );
          }
        },
        { Header: "Submitted On", accessor: "submittedOn" },
        { Header: "Submitted By", accessor: "submittedBy" }
      ];

const handleSelectedTab=(page)=>{
  setSelectedCurrentPage(page)

}

const handleAsinWiseProductList=(asin)=>{
  console.log(asin)
  let asinList=''
  if (asin=='Unmapped Assets'){
    asinList='Unmapped Assets'
    setSelectedASIN('Unmapped Assets')
  }
  else{asinList=asin.asin
     setSelectedASIN(asin.asin)}
  
  let data={
    integerId: props.selectedProjectData.integerId,
    assetCategory: props.selectedSubCategories.assetCategory,
    asinList: asinList,
    assetIdentifier:props.selectedProjectData.brand,
    status:[6,10], //6 Ready for Submissions 10 Signed Off
    subCategoryId: [7,5], //subcategory 7-graphics, 5 docments
    projectId:props.selectedProjectData.projectId,
  }
  FetchGraphicsAssetsAsinWiseService(props.token, data).then((res)=>{
    if(res){
      console.log(res)
      setSubmissionInnerCount(res.innerCountsOfSubmission)
      setFileList(res.fileList)
    // Assuming 5 is for documents, and 7 is for graphics
      const filterDocFileList = res.fileList && res.fileList.filter(file => file.assetSubCategory == 5); // for documents

      const filterGraphicsFileList = res.fileList && res.fileList.filter(file => file.assetSubCategory == 7); // for graphics

      setGraphicsFileList(filterGraphicsFileList);
      setDocFileList(filterDocFileList);

      
    }
  })
  const data1 = {
    projectId: props.selectedProjectData.projectId,
    submissionFor:asinList
   };
  FetchSubmissionListService(props.token, data1).then((res) => {
    if (res) {
      console.log(res)
      setSubmissionList(res.submissionList);
    }
  });
}
const getAsinCount = (asin) => {
  const match = asinCount.find(item => item.asinList === asin);
  return match ? match.count : 0; // return 0 if no count found
};



  return (
    <>
    <Row className='mr-0 ml-0'>
    <Col md={12}>
    <div className="d-flex align-items-center justify-content-between ml-3">
        <h5>
        <b>ASINs : </b>
        </h5>
        <div className="d-flex align-items-center w-75 justify-content-end mb-3">
          <Input
            type="text"
            placeholder="Search ASIN"
            className="w-25"
            value={searchASIN}
            onChange={(e) => setSearchASIN(e.target.value)}
          />
          {searchASIN && (
            <button
              className={`search-clear-button ${isSubmissionClosed ? "submission-search-closed" : "submission-search-open"}`}
              title="Clear"
              onClick={() => setSearchASIN("")}
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          )}
        </div>
      </div>
      {isSubmissionClosed && (
        <Row className="ml-3 mt-3">
          <Col md={3}>
            <Card
              className={`mb-3 ml-3 mt-2 p-3 text-center asin-card ${selectedASIN === "Unmapped Assets" ? "asin-sidebar-card-selected" : ""}`}
              onClick={() => {
                handleAsinWiseProductList("Unmapped Assets");
                setIsSubmissionClosed(false); 
              }}
              style={{ cursor: "pointer", position: "relative" , backgroundColor: "#dbc5e6"}}

            >
              <b>Unmapped Assets</b>
              <b
                className="assetsStatusCountSubmissions"
                style={{
                  minWidth: `${Math.max(24, unmappedCount.toString().length * 10)}px`,
                  minHeight: `${Math.max(24, unmappedCount.toString().length * 10)}px`,
                }}
              >
                {unmappedCount}
              </b>
            </Card>
          </Col>
          {filteredProductList && filteredProductList.map((asinObj, index) => (
            <Col md={3} key={index}>
              <Card
                title={asinObj.productTitle}
                className={`mb-3 ml-3 mt-2 p-3 text-center asin-card ${selectedASIN === asinObj.asin ? "asin-sidebar-card-selected" : ""}`}
                onClick={() => {
                  handleAsinWiseProductList(asinObj);
                  setIsSubmissionClosed(false); 
                }}
                style={{ cursor: 'pointer', position: 'relative' }}
              >
                <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <img
                  src={asinObj.itemImage}
                  alt={asinObj.productTitle}
                  style={{
                    width: "45px",
                    height: "45px",
                    objectFit: "contain",
                    borderRadius: "6px"
                  }}
                />
                <b style={{ fontSize: "14px" }}>{asinObj.asin}</b>
              </div>
              {/* ADDED: Display count for each ASIN */}
              <b
                className="assetsStatusCountSubmissions"
                style={{
                  minWidth: `${Math.max(24, getAsinCount(asinObj.asin).toString().length * 10)}px`,
                  minHeight: `${Math.max(24, getAsinCount(asinObj.asin).toString().length * 10)}px`,
                }}
              >
                {getAsinCount(asinObj.asin)}
              </b>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      </Col>
    </Row>
    {!isSubmissionClosed && (
    <Row className='mr-0 ml-0'>
      {/* Left Sidebar */}
      <Col md={2} className='mt-1'>
      <div className="asin-left-sidebar bg-white rounded shadow-sm p-3">
          <Card
            className={`mb-3 asin-sidebar-card ${selectedASIN === "Unmapped Assets" ? "asin-sidebar-card-selected" : ""}`}
            onClick={() => handleAsinWiseProductList("Unmapped Assets")}
            style={{ cursor: "pointer", position: "relative" , backgroundColor: "#dbc5e6"}}

          >
            {/* ADDED: Display unmapped count in sidebar */}
            <b>Unmapped Assets</b>
            <b
              className="assetsStatusCountSubmissions"
              style={{
                minWidth: `${Math.max(24, unmappedCount.toString().length * 10)}px`,
                minHeight: `${Math.max(24, unmappedCount.toString().length * 10)}px`,
              }}
            >
              {unmappedCount}
            </b>
          </Card>
          {filteredProductList && filteredProductList.map((asin, index) => (
            <Card
            title={asin.productTitle}
            key={index}
            className={`mb-3 asin-sidebar-card ${selectedASIN === asin.asin ? "asin-sidebar-card-selected" : ""}`}
            onClick={() => handleAsinWiseProductList(asin)}
            style={{ position: "relative" }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
              <img
                src={asin.itemImage}
                alt={asin.productTitle}
                style={{
                  width: "35px",
                  height: "35px",
                  objectFit: "contain",
                }}
              />
              <b>{asin.asin}</b>
              {/* ADDED: Display count badge in sidebar */}
              <b
                className="assetsStatusCountSubmissions"
                style={{
                  minWidth: `${Math.max(24, getAsinCount(asin.asin).toString().length * 10)}px`,
                  minHeight: `${Math.max(24, getAsinCount(asin.asin).toString().length * 10)}px`,
                }}
              >
                {getAsinCount(asin.asin)}
              </b>
            </div>
          </Card>
          ))}
        </div>
      </Col>

      {/* Right Section */}
      <Col md={10} className="p-2">
      <Card className="card-of-problemarea p-3 ml-3 shadow">
        {/* Tabs */}
        <div className="d-flex mb-0 ml-2">
          <h6
            className={`mr-2 ${selectedCurrentPage === 1 ? "selected-my-tasks" : "not-selected-tasks"
              }`}
            onClick={() => handleSelectedTab(1)}
            style={{ cursor: "pointer" }}
          >
            {/* <b>Documents {submissionInnerCount &&submissionInnerCount.document}</b> */}
            <b>
            Documents
            <span
              className="assetsStatusCount"
              style={{
                minWidth: `${Math.max(16,((submissionInnerCount && submissionInnerCount.document) || 0).toString().length * 10)}px`,
                minHeight: `${Math.max(16,((submissionInnerCount && submissionInnerCount.document) || 0).toString().length * 10)}px`,
                padding: `4px ${Math.max(6,((submissionInnerCount && submissionInnerCount.document) || 0).toString().length * 3)}px`}}
            >
              {(submissionInnerCount && submissionInnerCount.document) || 0}
            </span>
          </b>
          </h6>

          <h6
            className={`mr-2 ${selectedCurrentPage === 2 ? "selected-my-tasks" : "not-selected-tasks"
              }`}
            onClick={() => handleSelectedTab(2)}
            style={{ cursor: "pointer" }}
          >
            {/* <b>Graphics {submissionInnerCount &&submissionInnerCount.graphics}</b> */}
            <b>
            Graphics
            <span
              className="assetsStatusCount"
              style={{
                minWidth: `${Math.max(16,((submissionInnerCount && submissionInnerCount.graphics) || 0).toString().length * 10)}px`,
                minHeight: `${Math.max(16,((submissionInnerCount && submissionInnerCount.graphics) || 0).toString().length * 10)}px`,
                padding: `4px ${Math.max(6,((submissionInnerCount && submissionInnerCount.graphics) || 0).toString().length * 3)}px`}}
            >
              {(submissionInnerCount && submissionInnerCount.graphics) || 0}
            </span>
          </b>
          </h6>

          <h6
            className={`${selectedCurrentPage === 3 ? "selected-my-tasks" : "not-selected-tasks"
              }`}
            onClick={() => handleSelectedTab(3)}
            style={{ cursor: "pointer" }}
          >
            {/* <b>All {submissionInnerCount &&submissionInnerCount.total}</b> */}
            <b>
            All
            <span
              className="assetsStatusCount"
              style={{
                minWidth: `${Math.max(16,((submissionInnerCount && submissionInnerCount.total) || 0).toString().length * 10)}px`,
                minHeight: `${Math.max(16,((submissionInnerCount && submissionInnerCount.total) || 0).toString().length * 10)}px`,
                padding: `4px ${Math.max(6,((submissionInnerCount && submissionInnerCount.total) || 0).toString().length * 3)}px`}}
            >
              {(submissionInnerCount && submissionInnerCount.total) || 0}
            </span>
          </b> 
          </h6>
          <button className="card-close-button mr-2 mt-1" title="Close" onClick={() => setIsSubmissionClosed(true)}>
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>

        {/* Render Based on Tab */}
        {selectedCurrentPage === 1 && (
          <DocumentsSubmission
          setSubmissionInnerCount={setSubmissionInnerCount}
            fileList={docFileList}
            setFileList={setDocFileList}
            selectedProjectData={props.selectedProjectData}
            selectedSubCategories={props.selectedSubCategories}
            selectedASIN={selectedASIN}
            setSubmissionList={setSubmissionList}
            setAsinCount={setAsinCount}
            setUnmappedCount={setUnmappedCount}

          />
        )}
        {selectedCurrentPage === 2 && (
          <GraphicsSubmission
          setSubmissionInnerCount={setSubmissionInnerCount}
            fileList={graphicsfileList}
            setFileList={setGraphicsFileList}
            fileStatus={props.fileStatus}
            selectedProjectData={props.selectedProjectData}
            projectPermissions={props.projectPermissions}
            selectedSubCategories={props.selectedSubCategories}
            filterSubcategoryList={props.filterSubcategoryList}
            selectedASIN={selectedASIN}
            setSubmissionList={setSubmissionList}
            
            setAsinCount={setAsinCount}
            setUnmappedCount={setUnmappedCount}

          />
        )}
        {selectedCurrentPage === 3 && (
          <AllSubmission
          setSubmissionInnerCount={setSubmissionInnerCount}
            fileList={fileList}
            graphicsfileList={graphicsfileList}
            setGraphicsFileList={setGraphicsFileList}
            docFileList={docFileList}
            setDocFileList={setDocFileList}
            setFileList={setFileList}
            selectedProjectData={props.selectedProjectData}
            selectedASIN={selectedASIN}
            setSubmissionList={setSubmissionList}
            fileStatus={props.fileStatus}
            projectPermissions={props.projectPermissions}
            selectedSubCategories={props.selectedSubCategories}
            filterSubcategoryList={props.filterSubcategoryList}
            setAsinCount={setAsinCount}
            setUnmappedCount={setUnmappedCount}
          />
        )}
        </Card>

        {/* Table */}
        {/* Table */}
        <Card className="card-of-problemarea p-3 mt-3 ml-3 mb-2">
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="mb-0">
                <b>
                  Submission History 
                  {selectedASIN === "Unmapped Assets" 
                    ? ' for Project Assets'
                    : selectedASIN 
                      ? ` For ${selectedASIN}` 
                      : ' (All ASINs)'
                  }
                </b>
              </h5>
              <Input
                type="text"
                placeholder="Search submissions..."
                className="w-25"
                value={submissionSearchText}
                onChange={(e) => setSubmissionSearchText(e.target.value)}
              />
              {submissionSearchText && (
                <button 
                className="search-clear-button submission-search-closed"
                onClick={() => setSubmissionSearchText("")}
                title="Clear">
               <FontAwesomeIcon icon={faTimes} />
              </button>
              )}
            </div>
            <ReactTable
              className="-fixed -highlight -striped mt-2"
              columns={columns}
              data={filteredSubmissions}
              defaultPageSize={5}
              noDataText={
                selectedASIN === "Unmapped Assets"
                  ? "No submissions found"
                  : selectedASIN 
                    ? `No submissions found for ASIN: ${selectedASIN}` 
                    : "No submissions found..."
              }
              getTheadProps={() => ({
                style: {
                  overflow: "hidden",
                  background: "#B1FA63",
                  color: "#243837",
                },
              })}
            />
          </Card>
      </Col>
    </Row>
    )}
    <CustomModal
        isOpen={isSubmissionModalOpen}  
        toggle={() => setIsSubmissionModalOpen(false)}
        className="curve-popup"
        size="xl"
        header={
          selectedSubmission ? (
            <h5>
              Submitted for: {selectedSubmission.submittedFor} on{" "}
              {new Date(selectedSubmission.submittedOn).toISOString().slice(0, 19).replace("T", " ")}
            </h5>
          ) : (
            " "
          )
        }
      >
        {selectedSubmission && (
          <ProjectDashDeliveriesDetails
            submissionData={selectedSubmission}  
            onClose={() => setIsSubmissionModalOpen(false)}
            selectedProjectData={props.selectedProjectData}
            fileStatus={props.fileStatus}
                projectPermissions={props.projectPermissions}
                setSubmissionList={setSubmissionList}
          />
        )}
      </CustomModal>
    </>
  );
}

const mapStateToProps = (state) => ({
  token: state.loggedUser.token,
});

export default connect(mapStateToProps)(ProjectDashSubmissionMainPage);